import { render, staticRenderFns } from "./DotMenuPopover.vue?vue&type=template&id=591d6c25&scoped=true&"
import script from "./DotMenuPopover.vue?vue&type=script&lang=ts&"
export * from "./DotMenuPopover.vue?vue&type=script&lang=ts&"
import style0 from "./DotMenuPopover.vue?vue&type=style&index=0&id=591d6c25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d6c25",
  null
  
)

export default component.exports